import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {

  async searchByZip(e) {
    const input = e.target
    const zip = input.value.replace(/\D/g, "")

    if (zip.length !== 8) return

    try {
      const response = await fetch(`/warehouses/find_by_zipcode?zip=${zip}`)
      const data = await response.json()
      const address = document.querySelector("#warehouse_address")
      const neighborhood = document.querySelector("#warehouse_neighborhood")
      const country = document.querySelector("#warehouse_country_id")

      address.value = data.logradouro || ""
      neighborhood.value = data.bairro || ""

      country.value = data.country_id || ""
      if (country.value) {
        await this.visitFrame(`/warehouses/refresh_states?country_id=${country.value}`, "states_select")
      }

      const state = document.querySelector("#warehouse_state_id")
      if (state && data.state_id) {
        state.value = data.state_id
        await this.visitFrame(`/warehouses/refresh_cities?state_id=${state.value}`, "cities_select")
      }

      const city = document.querySelector("#warehouse_city_id")
      if (city) city.value = data.city_id || ""
    } catch (error) {
      console.log("CEP não encontrado", error)
    }
  }

  refreshStates(event) {
    const countryId = event.target.value
    if (!countryId) {
      Turbo.visit(`/warehouses/refresh_states?country_id=`, { frame: "states_select" })
      Turbo.visit(`/warehouses/refresh_cities?state_id=`, { frame: "cities_select" })
      return
    }

    Turbo.visit(`/warehouses/refresh_states?country_id=${countryId}`, { frame: "states_select" })
    Turbo.visit(`/warehouses/refresh_cities?state_id=`, { frame: "cities_select"  })
  }

  refreshCities(event) {
    const stateId = event.target.value
    if (!stateId) {
      return
      Turbo.visit(`/warehouses/refresh_cities?state_id=`, { frame: "cities_select" })
    }

    Turbo.visit(`/warehouses/refresh_cities?state_id=${stateId}`, { frame: "cities_select" })
  }

  visitFrame(url, frameId) {
    const frame = document.getElementById(frameId)
    if (!frame) {
      Turbo.visit(url, { frame: frameId })
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      const onLoad = () => resolve()
      frame.addEventListener("turbo:frame-load", onLoad, { once: true })
      Turbo.visit(url, { frame: frameId })
    })
  }
}
